import { useState } from "react";

import { UpdateIconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, pn } from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  ApplicationListDto,
  ApplicationListResource,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";

import { applicationPageRoute } from "../ApplicationPage/ApplicationPage";

export const ApplicationTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  applications: ApplicationListDto[];
  resource: ApplicationListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ApplicationListDto>("id"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<ApplicationListDto>("name"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.applications?.map((application) => (
            <TableRow
              key={application.id}
              onClick={() => navigate(applicationPageRoute.getPath({ id: application.id, crudMode: "view" }))}
            >
              <TableCell type="id">{application.id}</TableCell>
              <TableCell>{application.name}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() => navigate(applicationPageRoute.getPath({ id: application.id, crudMode: "edit" }))}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
